import { useState, useCallback, useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import TrustBar from '@/components/layout/TrustBar';
import StickyCTA from '@/components/layout/StickyCTA';
import WhatsAppWidget from '@/components/layout/WhatsAppWidget';
import IntroAnimation from '@/components/shared/IntroAnimation';
import HomePage from '@/pages/HomePage';
import RebrandPage from '@/pages/RebrandPage';
import ConsultingPage from '@/pages/ConsultingPage';
import LearningPage from '@/pages/LearningPage';
import ExecutiveSearchPage from '@/pages/ExecutiveSearchPage';
import AssessmentsPage from '@/pages/AssessmentsPage';
import EngagementPage from '@/pages/EngagementPage';
import BotsAIPage from '@/pages/BotsAIPage';
import ImpactPage from '@/pages/ImpactPage';
import AboutPage from '@/pages/AboutPage';
import ContactPage from '@/pages/ContactPage';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppContent() {
  return (
    <>
      <IntroAnimation />
      <Header />
      <main>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/our-new-chapter" element={<RebrandPage />} />
          <Route path="/consulting" element={<ConsultingPage />} />
          <Route path="/learning" element={<LearningPage />} />
          <Route path="/executive-search" element={<ExecutiveSearchPage />} />
          <Route path="/assessments" element={<AssessmentsPage />} />
          <Route path="/engagement" element={<EngagementPage />} />
          <Route path="/botsai" element={<BotsAIPage />} />
          <Route path="/impact" element={<ImpactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <TrustBar />
      <Footer />
      <StickyCTA />
      <WhatsAppWidget />
    </>
  );
}

function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-[#3D1C11] mb-4">404</h1>
        <p className="text-[#6B5B50] mb-6">Page not found.</p>
        <a href="/" className="bg-[#E8642C] text-white px-6 py-3 rounded-xl text-sm font-semibold hover:bg-[#CC2929] transition-colors">
          Back to Home
        </a>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
